import {
    faInbox, faTicketAlt, faPhoneAlt, faEnvelopeOpenText, faExclamationCircle,
    faBookOpen, faUserClock, faChartBar, faUserTie,
} from '@fortawesome/free-solid-svg-icons';

export const SUPPORT_NAV = [
    { to: '/support', label: 'Live Queue', icon: faInbox, end: true },
    { to: '/support/workbench', label: 'Ticket Workbench', icon: faTicketAlt },
    { to: '/support/calls', label: 'Call Center', icon: faPhoneAlt },
    { to: '/support/inbox', label: 'Omnichannel Inbox', icon: faEnvelopeOpenText },
    { to: '/support/complaints', label: 'Complaints Register', icon: faExclamationCircle },
    { to: '/support/knowledge-base', label: 'Knowledge Base', icon: faBookOpen },
    { to: '/support/on-call', label: 'Escalation & On-Call', icon: faUserClock },
    { to: '/support/analytics', label: 'Response Analytics', icon: faChartBar },
    { to: '/support/agents', label: 'Agent Performance', icon: faUserTie },
];

export const SLA_META: Record<string, { label: string; color: string }> = {
    on_track: { label: 'On track', color: 'success' },
    at_risk: { label: 'At risk (>24h)', color: 'warning' },
    breached: { label: 'Breached (>72h)', color: 'danger' },
    closed: { label: 'Closed', color: 'secondary' },
};

export const TICKET_STATUS_COLORS: Record<string, string> = {
    open: 'warning', 'in-progress': 'info', resolved: 'success', closed: 'secondary',
};

export const PRIORITY_COLORS: Record<string, string> = {
    low: 'secondary', medium: 'info', high: 'warning', urgent: 'danger', critical: 'danger',
};
